import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=3a2c578d&"
import script from "./Tile.vue?vue&type=script&lang=ts&"
export * from "./Tile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tile.vue"
export default component.exports